import React, { useState } from "react";
import Layout from "../../layout";
import { Loader } from "../../loader";
import Close from "../../../assets/images/close.png";
import Gift from "../../../assets/images/giftRupee.png";
import Rupee from "../../../assets/images/Indian-Rupee-Symbol.gif";
import Rupeesymbol from "../../../assets/images/rupeesymbol.png";
import CashReward from "../../../assets/images/cashReward.png";
import GiftReward from "../../../assets/images/giftReward.png";
import SuccessIcon from "../../../assets/images/successIcon.png";
import extraBonus from "../../../assets/images/extra bonus.png";
import SpinImageHi from "../../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../../assets/images/spinImage_te.png";
import SpinImageGj from "../../../assets/images/spinImage_gj.png";
import SpinImagePb from "../../../assets/images/spinImage_pb.png";
import SpinImageTa from "../../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../../assets/images/spinImage_en.png";
import SpinImageOr from "../../../assets/images/spinImage_or.png";
import SpinImageMa from "../../../assets/images/spinImage_ma.png";
import { Button } from "react-bootstrap";
import CustomModal from "../../modal";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchAPI } from "../../service/Encrtyption";
import { myRewards } from "../../auth/redux/store";
import ScanMoreImg from '../../../assets/images/Scanmore.png';
import ReactGA from 'react-ga4';
export const Reward = () => {
  const obj = {
    cashFreeTransactionId: 0,
    dsrId: 0,
    ecouponFarmerMapId: 0,
    moduleType: "Farmer",
    programId: 0,
    reClaim: "No",
    showView: false,
    countOfToBeClaims: 0,
    dsrProgramId: 0,
    ecouponFarmerId: 0,
    enableSprayService: false,
    isCortevaProduct: false,
    isLumivia: false,
    isProductAlreadyScaned: false,
    isSpinDone: false,
    lumiviaServReqRecordID: 0,
    multipleRewards: false,
    seadProgramId: 0,
    showClickableLink: false,
    showLuckyWinnerPopup: false,
    showRetailerIdPopup: false,
    uq_responseCode: 0,
    wheelStoppingIndex: 0,
    destinationURL: "/cashFreeReward/getCashFreeTransactionPendingRequest_V2",
  };
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(obj);
  const user = useSelector((state) => state?.user);
  const genunityData = useSelector((state) => state?.genunityData);
  const spinWheelData = useSelector((state) => state?.spinData);
  const secondaryMessage = useSelector((state) => state?.message);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mobileNumber = sessionStorage.getItem('mbn');
  const [errroMsg, setErrorMsg] = useState("");
  const browserType = sessionStorage.getItem("browserName") || "web";


  const hide = () => {
    setErrorMsg("");
  };


  const primaryRewardMsg = genunityData?.primaryRewardMsg;
  const multipleRewards = genunityData?.multipleRewards;
  const primaryRewardAmount = genunityData?.cashRewards;
  const bonusAmount = genunityData?.bonus;
  console.log(JSON.stringify(spinWheelData) + "----spinWheelData");
  const giftType = genunityData.cashRewards;


  // const handleRewardClick = async () => {

  //   ReactGA.event({
  //     category: 'User Reward Btn',
  //     action: 'CLK_REWARD_BTN'
  //   });

  //   setLoading(true);

  //   if (!mobileNumber) {
  //     setErrorMsg(t("sessionExperied"));
  //     setTimeout(() => {
  //       navigate(`/${lang}/home`);
  //     }, 2000);
  //     return;
  //   }

  //   try {
  //     const responseData = await fetchAPI(
  //       process.env.REACT_APP_API_URL,
  //       formData,
  //       {
  //         mobileNumber: mobileNumber,
  //         appLangCode: lang,
  //         deviceType: "web",
  //         browserType: browserType,
  //       }
  //     );
  //     const jsonReposneData = JSON.parse(responseData);
  //     dispatch(myRewards(jsonReposneData));
  //     navigate(`/${lang}/myrewards`)
  //     // if (multipleRewards == true) {
  //     //   navigate(`/${lang}/myrewards`)
  //     // } else {
  //     //   navigate(`/${lang}/paymentmode`)
  //     // }
  //     //console.log("API response of my rewards:", jsonReposneData);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'mr') {
    bannerLogoSrc = SpinImageMr;
  } else if (lang === 'kn') {
    bannerLogoSrc = SpinImageKa;
  } else if (lang === 'te') {
    bannerLogoSrc = SpinImageTe;
  } else if (lang === 'pa') {
    bannerLogoSrc = SpinImagePb;
  } else if (lang === 'gu') {
    bannerLogoSrc = SpinImageGj;
  } else if (lang === 'ta') {
    bannerLogoSrc = SpinImageTa;
  } else if (lang === 'bn') {
    bannerLogoSrc = SpinImageBn;
  } else if (lang === 'en') {
    bannerLogoSrc = SpinImageEn;
  } else if (lang === 'or') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'ma') {
    bannerLogoSrc = SpinImageHi;
  }
  else {
    bannerLogoSrc = SpinImageHi;
  }


  return (
    <>
      <Layout>
        <div className="container p-0">
          {loading && <Loader />}
          <div className="card border-0">
            <div className="card-body px-2 pt-0 pb-2">
              <div className="container text-center mt-4">

                {spinWheelData?.giftContent && (
                  <> 
                    <p
                      dangerouslySetInnerHTML={{
                        __html: spinWheelData?.giftContent?.replace(/\n/g, "<br/>") || "",
                      }}
                    /> 
                    {/* <h5 className="card-title mb-1">{t('congratulationsYouWon')}</h5>
                    <p className="card-text mb-0">सैमसंग गैलेक्सी M07</p> */}
                  </>
                )}

                <div className="text-center rewardContent">
                  {spinWheelData?.congratsImageUrl && (<div>
                    <img src={spinWheelData.congratsImageUrl} alt="success" className="img-fluid w-100" />
                  </div>
                  )}
                </div>

                {spinWheelData?.primaryRewardMsg && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: spinWheelData?.primaryRewardMsg?.replace(/\n/g, "<br/>") || "",
                    }}
                  />
                )}

                {/* <h4 className="text-center mt-4 mb-3 mobileinfoText">हम आपके रजिस्टर्ड मोबाइल नंबर पर जल्द ही संपर्क करेंगे।</h4>

                <div className="my-4">
                  <p className="mb-0 scanCountText">कुल गैलेंट पैकेट स्कैन किए</p>
                  <h2 className="text-center text-secondaryColor mb-0 scanCount">5</h2>
                </div>

                <p className="scanCountText">और स्कैन करें = और शॉट्स = और मौके!</p> */}

                <div className="d-flex flex-direction-column" style={{ gap: '1rem' }}>
                  <Button className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}
                    onClick={() => {
                      ReactGA.event({
                        category: 'Btn',
                        label: 'User Scan More',
                        action: 'Clicked Scan More Button - Reward Page'
                      });
                      navigate(`/${lang}/scanProduct`)
                    }
                    }
                  >
                    {t("Scanmore")}
                  </Button>

                  {spinWheelData?.giftContent && (<Button className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}
                    onClick={() => {
                      ReactGA.event({
                        category: "User Share",
                        label: "Share Now Button",
                        action: "Clicked Share Now Button - Reward Page",
                      });
                      navigate(`/${lang}/awardshare`);
                    }}>
                    {t('ShareNow')}
                  </Button>)}

                </div>

                {/* <img src={bannerLogoSrc} alt="Right" className="spinImgae spinwheelImg" />

                {primaryRewardAmount && (<div className="giftImg giftedAmount">
                  <img src={Rupeesymbol} alt="rupeesymbol" className="mr-1" />
                  {primaryRewardAmount}
                  {bonusAmount > 0 && (
                    <div className="extraBonusImg">
                      <img src={extraBonus} alt="Right" className="img-fluid" style={{ width: '200px' }} />
                    </div>
                  )}
                </div>
                )}
                <div className="text-center rewardContent">
                  <button type="button" className="close" aria-label="Close">
                    <img src={Close} alt="Close" />
                  </button>
                  <div style={{ marginTop: primaryRewardAmount ? '3.5rem' : '1rem' }}>
                    <img src={Rupee} alt="rupee" style={{width:'120px'}} />
                    {primaryRewardAmount && (<p className="congratulationsText">
                      {" "}
                      {t("congratulations")} !!!
                    </p>
                    )}
                    <p className='rewardText'> {t("earned")}</p>
                    <p className="rewardText" dangerouslySetInnerHTML={{ __html: primaryRewardMsg }}></p>
                    {secondaryMessage && (<p className="rewardText" dangerouslySetInnerHTML={{ __html: secondaryMessage }}></p>)}
                  </div>
                </div>
                <div className="border-0 gap-2  mt-4 d-flex text-center align-items-center">
                  <div className="w-100">
                    <div>
                      <img src={CashReward} alt="Cash" />
                    </div>
                    <button
                      type="button"
                      className="w-100 mt-2 rounded-4 py-2 btn btn-primary rewardBtns"
                      onClick={handleRewardClick}
                      disabled={giftType > 0 ? false : true}
                    >
                      {t("redeemCash")}
                    </button>
                  </div>

                  <div className="w-100">
                    <div>
                      <img src={ScanMoreImg} alt="Cash" style={{ width: "62px" }} />
                    </div>
                    <button
                      type="button"
                      className="w-100 mt-2 rounded-4 py-2 btn btn-primary rewardBtns"
                      onClick={() => {
                        ReactGA.event({
                          category: 'User Scan More',
                          action: 'Clicked the Scan More Button',
                        });
                        navigate(`/${lang}/scanProduct`)
                      }}
                    >
                      {t("Scanmore")}
                    </button>
                  </div>

                  {errroMsg && (
                    <>
                      <div
                        className="alert alert-warning alert-dismissible fade show mt-2"
                        role="alert"
                      >
                        {errroMsg}
                        <button
                          type="button"
                          className="close"
                          onClick={hide}
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};
